export default {
      id: "oc-res-proxysetting-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-proxysetting",
      toString: function () {
        return this.url;
      }
    }